var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArmchair = function SvgIconArmchair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.5 7.453V6.75a4 4 0 0 1 4-4h9a4 4 0 0 1 4 4v.703a4.75 4.75 0 0 1 0 9.094v2.203a1.75 1.75 0 0 1-1.75 1.75H5.25a1.75 1.75 0 0 1-1.75-1.75v-2.203a4.749 4.749 0 0 1 0-9.094m2.586-2.117A2 2 0 0 1 7.5 4.75h9a2 2 0 0 1 2 2v.541a4.75 4.75 0 0 0-4.118 4.459H9.618A4.75 4.75 0 0 0 5.5 7.291V6.75a2 2 0 0 1 .586-1.414M4.595 9.264h.012A2.75 2.75 0 0 1 7.625 12v3.375a1 1 0 0 0 2 0V13.75h4.75v1.625a1 1 0 0 0 2 0V12a2.75 2.75 0 1 1 3.025 2.736 1 1 0 0 0-.9.995V18.5h-13v-2.769a1 1 0 0 0-.9-.995 2.75 2.75 0 0 1-.005-5.472",
    clipRule: "evenodd"
  })));
};
export default SvgIconArmchair;